// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"system-setting"},"children":[{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M21.5 17.5C21.5 19.1569 20.1569 20.5 18.5 20.5C16.8431 20.5 15.5 19.1569 15.5 17.5C15.5 15.8431 16.8431 14.5 18.5 14.5C20.1569 14.5 21.5 15.8431 21.5 17.5Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M22 9.5V3H2V17H10.5M4 21H10.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M18.4999 14.5V13.25M18.4999 14.5C16.8431 14.5 15.4999 15.8431 15.4999 17.5C15.4999 19.1569 16.8431 20.5 18.4999 20.5M18.4999 14.5C20.1568 14.5 21.4999 15.8431 21.4999 17.5C21.4999 19.1569 20.1568 20.5 18.4999 20.5M18.4999 20.5V21.75M15.9019 16L14.8193 15.375M21.098 19L22.1806 19.625M21.098 16L22.1806 15.375M15.9019 19L14.8193 19.625","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const SystemSettingIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'system-setting',
    ref,
    icon: element,
  },
));

SystemSettingIcon.displayName = 'SystemSettingIcon';

export default SystemSettingIcon;
